module.exports = __webpack_public_path__ + "static/home2-4181e47621bb492596098123cb7eac51.gif";